import { ActionTree } from "vuex";
import { NewslettersState } from "./types";
import { RootState } from "../types";

import { endpoints } from "../../endpoints";
import Vue from "vue";

export const actions: ActionTree<NewslettersState, RootState> = {
    // Gets a list of the newsletters that the user has enabled on their account.
    list({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            Vue.axios({
                url: endpoints.newslettersListUrl,
                method: "GET",
            })
                .then((response: any) => {
                    commit("newsletters", response.data);
                    resolve(response);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    },

    // Subscribes the user to a newsletter.
    subscribe({ commit, dispatch }, data) {
        return new Promise((resolve, reject) => {
            Vue.axios({
                url: endpoints.newslettersSubscribeUrl(data),
                method: "POST",
            })
                .then((response: any) => {
                    //commit("newsletters", response.data);
                    resolve(response);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    },

    // Unsubscribes the user to a newsletter.
    unsubscribe({ commit, dispatch }, data) {
        return new Promise((resolve, reject) => {
            Vue.axios({
                url: endpoints.newslettersUnsubscribeUrl(data),
                method: "POST",
            })
                .then((response: any) => {
                    //commit("newsletters", response.data);
                    resolve(response);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    },
};
